import {Component, OnInit, ViewChild} from '@angular/core';
import {ItemsService} from "../../core/http/items.service";
import {MatDialog} from "@angular/material/dialog";
import {MatSnackBar} from "@angular/material/snack-bar";
import {Category} from "../../shared/models/category";
import {PrinterDto} from "../../shared/models/printer-dto";
import {PrinterService} from "../../core/http/printer.service";
import {
  CategoryDetailsPopupComponent
} from "../category-overview/category-details-popup/category-details-popup.component";
import {PrinterDetailsPopupComponent} from "./printer-details-popup/printer-details-popup.component";
import {YesNoModalComponent} from "../../shared/components/yes-no-modal/yes-no-modal.component";
import {PrinterCategoryQueueAssignmentDto} from "../../shared/models/printer-category-queue-assignment-dto";
import {Tenant} from "../../shared/models/tenant";
import {MatTableDataSource} from "@angular/material/table";
import {MatSort} from "@angular/material/sort";
import {Waiter} from "../../shared/models/waiter";

@Component({
  selector: 'app-printer-overview',
  templateUrl: './printer-overview.component.html',
  styleUrl: './printer-overview.component.scss'
})
export class PrinterOverviewComponent implements OnInit {

  printers: PrinterDto[] = [];
  tenants: Tenant[] = [];
  printCategories: PrinterCategoryQueueAssignmentDto[] = [];
  displayedColumns: string[] = ['name', 'location', 'ipAddress', 'port', 'printCategoryIdentifier', 'tenantName', 'backupForOtherCategories', 'details', 'delete'];

  currentSelectedPrinter = '';

  dataSource!: MatTableDataSource<PrinterDto>;
  printerFilterValues: string[] = [];
  @ViewChild(MatSort, {static: true}) sort!: MatSort;

  constructor(private printerService: PrinterService, private itemService: ItemsService,
              private dialog: MatDialog, private _snackBar: MatSnackBar) { }

  ngOnInit(): void {
    this.loadData();
  }

  loadData(): void {
    this.printerService.getAllPrinters().subscribe({
      next: (response) => {
        this.printers = <PrinterDto[]>response;
        this.dataSource = new MatTableDataSource<PrinterDto>(this.printers);
        this.dataSource.filterPredicate = (data: PrinterDto, filter: string) => {
          return data.tenantName?.toLowerCase() === filter;
        };
        this.dataSource.sort = this.sort;
        this.populatePrinterFilterValues();
        if (this.currentSelectedPrinter !== '') {
          this.applyFilter(this.currentSelectedPrinter);
        }
      },
      error: (error) => {
        console.log(error);
      }
    });

    this.printerService.getAllQueuePrintAssignments().subscribe({
      next: (response) => {
        this.printCategories = (<PrinterCategoryQueueAssignmentDto[]> response);
      },
      error: (error) => {
        console.log(error);
      }
    });

    this.printerService.getAllTenants().subscribe({
      next: (response) => {
        this.tenants = (<Tenant[]> response);
      },
      error: (error) => {
        console.log(error);
      }
    });

  }

    populatePrinterFilterValues() {
      const printersSet = new Set<string>();
      this.printers.forEach(printer => {
        if (printer.tenantName != null) {
          printersSet.add(printer.tenantName);
        }
      });
      this.printerFilterValues = Array.from(printersSet);
    }

    applyFilter(filterValue: string) {
      this.currentSelectedPrinter = filterValue;
      this.dataSource.filter = filterValue.trim().toLowerCase();
    }

  createPrinter(): void {
    this.dialog.open(PrinterDetailsPopupComponent, {
      data: {
        item: {},
        printCategories: this.printCategories,
        tenants: this.tenants
      },
      width: '600px', // Set the width of the popup as per your preference
      panelClass: 'ordermate-dialog-panel'
    }).afterClosed().subscribe(result => {
      // console.log(result)
      if (result) {
        this.printerService.createPrinter(result).subscribe({
          next: (response) => {
            this._snackBar.open('Drucker erstellt', 'Schließen', {duration: 3000});
            this.ngOnInit();
          },
          error: (error) => {
            console.log(error);
          }
        });
      }
    });
  }

  showPrinterDetails(printer: PrinterDto): void {
    this.dialog.open(PrinterDetailsPopupComponent, {
      data: {
        item: printer,
        printCategories: this.printCategories,
        tenants: this.tenants
      },
      width: '600px', // Set the width of the popup as per your preference
      panelClass: 'ordermate-dialog-panel'
    }).afterClosed().subscribe(result => {
      console.log(result)
      if (result) {
        result.guid = printer.guid;
        this.printerService.updatePrinter(result).subscribe({
          next: (response) => {
            this._snackBar.open('Drucker geändert', 'Schließen', {duration: 3000});
            this.ngOnInit();
          },
          error: (error) => {
            console.log(error);
          }
        });
      }
    });
  }

  deletePrinter(printer: PrinterDto): void {
    this.dialog.open(YesNoModalComponent, {
      data: printer.name,
      width: '400px'
    }).afterClosed().subscribe(result => {
      if (result) {
        this.printerService.deletePrinter(printer.guid).subscribe(result => {
          this._snackBar.open('Drucker ' + printer.name + ' gelöscht', 'Schließen', {duration: 3000});
          this.ngOnInit();
        });
      }
    });
  }

}
